import { SxProps, Theme } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

const styles: SxProps<Theme> = {
  color: blueGrey[800],
  whiteSpace: 'pre-line',
};

export default styles;
